import * as React from 'react';

import { sections } from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';

import { SectionContentLinkListIdOne } from 'components/section-content-link-list';
import { TitleAnchor } from 'components/title-anchor';
import { FormattedText, P1 } from 'components/typography';

import { getPropsSectionOneTextContainer } from './section-one-text-container.props';

const setTitleElement = (id: SectionContentLinkListIdOne) => {
  const mapTitleAnchorToSectionId: {
    [key in SectionContentLinkListIdOne]: {
      id: SectionContentLinkListIdOne;
      title: string;
    };
  } = {
    [SectionContentLinkListIdOne.RegistrationInformation]: {
      id: SectionContentLinkListIdOne.RegistrationInformation,
      title: sections.tabOneSection.section1.title(),
    },

    [SectionContentLinkListIdOne.LinkedSocialMediaInformation]: {
      id: SectionContentLinkListIdOne.LinkedSocialMediaInformation,
      title: sections.tabOneSection.section2.title(),
    },

    [SectionContentLinkListIdOne.ProfileVerificationInformation]: {
      id: SectionContentLinkListIdOne.ProfileVerificationInformation,
      title: sections.tabOneSection.section3.title(),
    },
    [SectionContentLinkListIdOne.PurchaseInformation]: {
      id: SectionContentLinkListIdOne.PurchaseInformation,
      title: sections.tabOneSection.section4.title(),
    },
    [SectionContentLinkListIdOne.GeolocationInformation]: {
      id: SectionContentLinkListIdOne.GeolocationInformation,
      title: sections.tabOneSection.section5.title(),
    },
    [SectionContentLinkListIdOne.DeviceInformation]: {
      id: SectionContentLinkListIdOne.DeviceInformation,
      title: sections.tabOneSection.section6.title(),
    },
    [SectionContentLinkListIdOne.PhotoInformation]: {
      id: SectionContentLinkListIdOne.PhotoInformation,
      title: sections.tabOneSection.section7.title(),
    },
    [SectionContentLinkListIdOne.LinkInformation]: {
      id: SectionContentLinkListIdOne.LinkInformation,
      title: sections.tabOneSection.section8.title(),
    },
    [SectionContentLinkListIdOne.BumbleSuccessStories]: {
      id: SectionContentLinkListIdOne.BumbleSuccessStories,
      title: sections.tabOneSection.section9.title(),
    },
    [SectionContentLinkListIdOne.CustomerSupportContactInformation]: {
      id: SectionContentLinkListIdOne.CustomerSupportContactInformation,
      title: sections.tabOneSection.section10.title(),
    },
    [SectionContentLinkListIdOne.CookiesAndSimilarTechnologyInformation]: {
      id: SectionContentLinkListIdOne.CookiesAndSimilarTechnologyInformation,
      title: sections.tabOneSection.section11.title(),
    },
    [SectionContentLinkListIdOne.Messages]: {
      id: SectionContentLinkListIdOne.Messages,
      title: sections.tabOneSection.section12.title(),
    },
  };

  return <TitleAnchor {...mapTitleAnchorToSectionId[id]} />;
};

export const getPropsSectionOneContainer = () => {
  const sectionOneText = getPropsSectionOneTextContainer();
  return {
    sections: {
      one: {
        intro: sections.tabOneSection.section1.intro(),
        imageSrc: `${CdnImagePath}/assets/tab-01/tab-01-02.jpg`,
        imageAlt: '',
        imageObjectPosition: 'top center',
        imageText: <P1 as="p">{sections.tabOneSection.section1.speechBox()}</P1>,
        title: setTitleElement(SectionContentLinkListIdOne.RegistrationInformation),
        text: sectionOneText,
      },
      two: {
        title: setTitleElement(SectionContentLinkListIdOne.LinkedSocialMediaInformation),
        text: sections.tabOneSection.section2.text(),
        imageSrc: `${CdnImagePath}/assets/tab-01/tab-01-03.jpg`,
        imageAlt: '',
        imageObjectPosition: 'top center',
        subSection1: {
          title: sections.tabOneSection.section2.subsection1.title(),
          facebook: {
            text: (
              <FormattedText>
                <P1 html={sections.tabOneSection.section2.subsection1.facebook.text1()} as="p" />
                <P1 html={sections.tabOneSection.section2.subsection1.facebook.text2()} as="div" />
              </FormattedText>
            ),
          },
          apple: {
            text: (
              <FormattedText>
                <P1 html={sections.tabOneSection.section2.subsection1.apple.text1()} as="p" />
                <P1 html={sections.tabOneSection.section2.subsection1.apple.text2()} as="div" />
              </FormattedText>
            ),
            speechBox: sections.tabOneSection.section2.subsection1.apple.speechBox(),
          },
          lastText: sections.tabOneSection.section2.subsection1.lastText(),
        },
        subSection2: {
          title: sections.tabOneSection.section2.subsection2.title(),
          text: (
            <FormattedText>
              <P1 as="p">{sections.tabOneSection.section2.subsection2.text1()}</P1>
              <P1 as="p">{sections.tabOneSection.section2.subsection2.text2()}</P1>
              <P1 as="p">{sections.tabOneSection.section2.subsection2.text3()}</P1>
            </FormattedText>
          ),
          goodToKnow: {
            title: sections.tabOneSection.section2.subsection2.goodToKnow.title(),
            content: sections.tabOneSection.section2.subsection2.goodToKnow.content(),
          },
        },
      },
      three: {
        imageSrc: `${CdnImagePath}/assets/tab-01/tab-01-04.png`,
        imageAlt: '',
        imageObjectPosition: 'top center',
        title: setTitleElement(SectionContentLinkListIdOne.ProfileVerificationInformation),
        text: (
          <FormattedText>
            <P1 as="p" html={sections.tabOneSection.section3.text1()} />
            <P1 as="p" html={sections.tabOneSection.section3.text2()} />
            <P1 as="p" html={sections.tabOneSection.section3.text3()} />
            <P1 as="p" html={sections.tabOneSection.section3.text4()} />
          </FormattedText>
        ),
      },
      four: {
        title: setTitleElement(SectionContentLinkListIdOne.PurchaseInformation),

        text: (
          <FormattedText>
            <P1 as="p" html={sections.tabOneSection.section4.text1()} />
            <P1 as="p" html={sections.tabOneSection.section4.text2()} />
          </FormattedText>
        ),
        goodToKnow: {
          title: sections.tabOneSection.section4.goodToKnow.title(),
          content: sections.tabOneSection.section4.goodToKnow.content(),
        },
      },
      five: {
        title: setTitleElement(SectionContentLinkListIdOne.GeolocationInformation),
        text: (
          <FormattedText>
            <P1 as="p">{sections.tabOneSection.section5.text1()}</P1>
            <P1 as="p">{sections.tabOneSection.section5.text2()}</P1>
            <P1 as="p">{sections.tabOneSection.section5.text3()}</P1>
          </FormattedText>
        ),
        goodToKnow: {
          title: sections.tabOneSection.section5.goodToKnow.title(),
          text: (
            <div className="list-update">
              <FormattedText>
                <P1 html={sections.tabOneSection.section5.goodToKnow.content1()} as="p" />
                <P1 html={sections.tabOneSection.section5.goodToKnow.content2()} as="div" />
              </FormattedText>
            </div>
          ),
          content: [
            sections.tabOneSection.section5.goodToKnow.content1(),
            sections.tabOneSection.section5.goodToKnow.content2(),
          ],
        },
      },
      six: {
        title: setTitleElement(SectionContentLinkListIdOne.DeviceInformation),
        text: (
          <FormattedText>
            <P1 as="p">{sections.tabOneSection.section6.text()}</P1>
          </FormattedText>
        ),
        imageSrc: `${CdnImagePath}/assets/tab-01/tab-01-05.jpg`,
        imageAlt: '',
        imageObjectPosition: 'top center',
      },
      seven: {
        title: setTitleElement(SectionContentLinkListIdOne.PhotoInformation),
        text: (
          <FormattedText>
            <P1 as="p">{sections.tabOneSection.section7.text()}</P1>
          </FormattedText>
        ),
        imageSrc: `${CdnImagePath}/assets/tab-01/tab-01-06.jpg`,
        imageAlt: '',
        imageObjectPosition: 'top center',
      },
      eight: {
        title: setTitleElement(SectionContentLinkListIdOne.LinkInformation),
        text: (
          <FormattedText>
            <P1 as="p">{sections.tabOneSection.section8.text()}</P1>
          </FormattedText>
        ),
        imageSrc: `${CdnImagePath}/assets/tab-01/tab-01-07.jpg`,
        imageAlt: '',
        imageObjectPosition: 'top center',
      },
      twelve: {
        title: setTitleElement(SectionContentLinkListIdOne.Messages),
        text: (
          <FormattedText>
            <P1 as="div" html={sections.tabOneSection.section12.text()} />
          </FormattedText>
        ),
      },
      nine: {
        title: setTitleElement(SectionContentLinkListIdOne.BumbleSuccessStories),
        text: (
          <FormattedText>
            <P1 as="p" html={sections.tabOneSection.section9.text1()} />
            <P1 as="p" html={sections.tabOneSection.section9.text2()} />
          </FormattedText>
        ),
        imageSrc: `${CdnImagePath}/assets/tab-01/tab-01-08.jpg`,
        imageAlt: '',
        imageObjectPosition: 'top center',
      },
      ten: {
        title: setTitleElement(SectionContentLinkListIdOne.CustomerSupportContactInformation),
        text: (
          <FormattedText>
            <P1 as="div" html={sections.tabOneSection.section10.text1()} />
          </FormattedText>
        ),
        imageSrc: `${CdnImagePath}/assets/tab-01/tab-01-09.jpg`,
        imageAlt: '',
        imageObjectPosition: 'top center',
      },
      eleven: {
        title: setTitleElement(SectionContentLinkListIdOne.CookiesAndSimilarTechnologyInformation),
        text: (
          <FormattedText>
            <P1 as="p" html={sections.tabOneSection.section11.text1()} />
            <P1 as="p" html={sections.tabOneSection.section11.text2()} />
          </FormattedText>
        ),
        whatIsACookie: {
          title: sections.tabOneSection.section11.whatIsACookie.title(),
          content: sections.tabOneSection.section11.whatIsACookie.content(),
        },
      },
    },
  };
};
